<template>
  <fragment>
    <mc-app-header title="Concept Versions" />
    <mc-app-body>
      <b-loading v-if="concepts.loading" active :is-full-page="false" />
      <mc-error-layout
        v-else-if="concepts.loadError"
        message="Failed to load concept versions!"
        :retry-fn="load"
      />
      <div v-else class="versions section">
        <div v-if="noVersions" class="versions__empty box has-text-centered">
          <div class="content">
            This concept is not yet published
          </div>
        </div>
        <div v-else class="versions_list mc-container">
          <div
            v-for="(version, index) in versions"
            :key="index"
            class="versions__item box"
          >
            <div class="versions__item-desc">
              <div class="versions__item-title content">
                {{ version.name }}
              </div>
              <b-field grouped group-multiline>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Version</b-tag>
                    <b-tag type="is-info">{{ version.version }}</b-tag>
                  </b-taglist>
                </div>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Videos</b-tag>
                    <b-tag type="is-success">
                      {{ version.steps.filter(v => v.type === 'video').length }}
                    </b-tag>
                  </b-taglist>
                </div>
                <div class="control">
                  <b-taglist attached>
                    <b-tag type="is-dark">Tests</b-tag>
                    <b-tag type="is-success">
                      {{ version.steps.filter(v => v.type === 'test').length }}
                    </b-tag>
                  </b-taglist>
                </div>
                <div v-if="index === 0" class="control">
                  <b-tag type="is-success">
                    Latest
                  </b-tag>
                </div>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import sortBy from 'lodash/sortBy';

export default {
  computed: {
    ...mapState(['concepts']),
    conceptId() {
      return this.$route.params.id;
    },
    noVersions() {
      return this.versions.length === 0;
    },
    versions() {
      return sortBy(this.concepts.versions, o => 10000 - parseFloat(o.version));
    }
  },
  methods: {
    ...mapActions('concepts', ['bindVersions']),
    load() {
      this.bindVersions({ conceptId: this.conceptId });
    }
  },
  created() {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
.versions {
  &__item-title {
    margin-bottom: 0.5rem;
  }
}
</style>
